import awsAmplifyFilter from "@/plugins/sentry/filters/awsAmplifyFilter";
import networkFilter from "@/plugins/sentry/filters/networkFilter";
import externalScriptFilter from "@/plugins/sentry/filters/externalScriptFilter.js";
import { envIsLocalOrDev } from "@/config";

const sentryEventFilter = (event, hint) => {
  try {
    if (awsAmplifyFilter(event, hint) || externalScriptFilter(event, hint) || networkFilter(event, hint)) {
      return null;
    }
  } catch (e) {
    console.log("could not filter error", e);
  }

  if (envIsLocalOrDev) {
    console.error(hint.originalException);
  }

  return event;
};

export { sentryEventFilter };
